import { Flow } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Flow';
import { StateViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/StateViewModel';
export class FlowViewModel {
    /**
     * Creates a view model from a flow model.
     * @param flow
     */
    static create(flow) {
        if (!flow.states.length) {
            return;
        }
        const flowViewModel = flow.states.reduce((f, state) => {
            const stateViewModel = StateViewModel.create(state);
            f[state.id] = stateViewModel;
            return f;
        }, new FlowViewModel());
        return flowViewModel;
    }
    /**
     * Creates a flow model instance to an view model.
     * @param flowViewModel
     */
    static createModel(flowViewModel, flowConfigurationViewModel, id, version = 1) {
        const flow = new Flow();
        flow.id = id;
        flow.version = version;
        flow.states = Object.keys(flowViewModel).map((k) => StateViewModel.createModel(flowViewModel[k]));
        flow.configuration = flowConfigurationViewModel;
        return flow;
    }
}
